// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs-items[data-v-19e56254]{background-color:transparent}", ""]);
// Exports
module.exports = exports;
